const CallMapTab = () => {
  return <div className="map"></div>;
};

export default CallMapTab;
